import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Save, XCircle, Plus, RefreshCcw, Trash2, Printer, Edit, ChevronDown } from 'lucide-react';
import Header from './Header';
import api from '../api/api';

const OrderProcess = ({ setIsLoggedIn }) => {
   const navigate = useNavigate();
   const handleLogout = () => {
     sessionStorage.removeItem("isLoggedIn");
     sessionStorage.removeItem("username");
     sessionStorage.removeItem("lastVisited");
     setIsLoggedIn(false);
   };

   
  const [message, setMessage] = useState('');
  const [messageVisible, setMessageVisible] = useState(false);
  const [messageColor, setMessageColor] = useState('bg-gray-800');
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [totalClBalance, setTotalClBalance] = useState(0);
  const [totalNetAmount, setTotalNetAmount] = useState(0);
  const [orderDate, setOrderDate] = useState('');
  const [itemType, setItemType] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [itemTypes, setItemTypes] = useState([]);
  const [deliveryPersons, setDeliveryPersons] = useState([]);
  const [payModes, setPayModes] = useState([]);
  const [searchTextMode, setSearchTextMode] = useState('');
  const [dropdownOpenMode, setDropdownOpenMode] = useState(false);
  const [searchTextDelivery, setSearchTextDelivery] = useState('');
  const [dropdownOpenDelivery, setDropdownOpenDelivery] = useState(false);
  const [searchTextItemType, setSearchTextItemType] = useState('');
  const [dropdownOpenItemType, setDropdownOpenItemType] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const dropdownRefItemType = useRef(null);
  const [modeDropdownStates, setModeDropdownStates] = useState({});
  const [selectedOrderIds, setSelectedOrderIds] = useState([]);
  const [activeTab, setActiveTab] = useState('OrderProcess');
  const [orderSummaryData, setOrderSummaryData] = useState([]);

  const hiddenCol = "hidden";


const filteredPayModes = payModes.filter(m =>
  m.PayMode &&
  m.PayMode.toLowerCase().includes(searchTextMode.toLowerCase())
);

const filteredItemTypes = [{ItemType: ''}, ...itemTypes].filter(type =>
  (type.ItemType || '').toLowerCase().includes(searchTextItemType.toLowerCase())
);
  useEffect(() => {
     const today = new Date().toISOString().split('T')[0];
     setOrderDate(today);
    
     // Initial load from orders state (empty initially)
     let filtered = orders.filter(order => {
       return  order.item_type === itemType;
     });

    if (searchInput) {
      filtered = filtered.filter(order =>
        order.Customer.toLowerCase().includes(searchInput.toLowerCase()) ||
        String(order.BIllNo).includes(searchInput)||
         String(order.VCode).includes(searchInput)
      );
    }

    setFilteredOrders(filtered);
    setTotalOrders(filtered.length);
    const clBalanceSum = filtered.reduce((sum, order) => sum + (order.ClBalance || 0), 0);
    const netAmountSum = filtered.reduce((sum, order) => sum + (order.NetAmount || 0), 0);
    setTotalClBalance(clBalanceSum);
    setTotalNetAmount(netAmountSum);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const username = sessionStorage.getItem("username") || "UnknownUser";
        const response = await api.GetOrderProcessAPI(username, '1');
        if (response.GetOrderProcessAPIjs) {
          setItemTypes(response.GetOrderProcessAPIjs.Table || []);
          setDeliveryPersons(response.GetOrderProcessAPIjs.Table1 || []);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  const showMessage = (text, color = 'bg-gray-800') => {
    setMessage(text);
    let bgColor;
    if (color === 'Delete') bgColor = 'bg-red-600';
    else if (color === 'Print') bgColor = 'bg-yellow-600';
    else if (color === 'Update') bgColor = 'bg-indigo-600';
    else if (color === 'bg-vivid-orange') bgColor = 'bg-orange-500';
    else bgColor = color;
    setMessageColor(bgColor);
    setMessageVisible(true);
    setTimeout(() => {
      setMessageVisible(false);
    }, 3000);
  };

  const simulateAction = (billNo, action) => {
    let message = '';
    if (action === 'Delete') {
      message = `Order Bill No. ${billNo} is marked for Deletion.`;
    } else if (action === 'Print') {
      message = `Printing Bill No. ${billNo}...`;
    } else if (action === 'Update') {
      message = `Redirecting to Edit Screen for Bill No. ${billNo}...`;
    }
    showMessage(message, action);
  };

  const preventScroll = (e) => {
    e.preventDefault();
  };

  const handleFocusAddWheelBlock = (ev) => {
    // non-passive so preventDefault() works
    ev.target.addEventListener("wheel", preventScroll, { passive: false });
  };

  const handleBlurRemoveWheelBlock = (ev) => {
    ev.target.removeEventListener("wheel", preventScroll, { passive: false });
  };

 const updateRemark = (poId, field, value) => {
  setOrders(prevOrders =>
    prevOrders.map(order =>
      order.PoId === poId ? { ...order, [field]: value } : order
    )
  );
};


  // const handleDelete = async (order) => {
  //   try {
  //     await api.DeleteSimpleOrderAPI(order.PoId, orderDate, itemType);
  //     showMessage('Order deleted successfully.', 'Delete');
  //     loadOrders();
  //   } catch (error) {
  //     console.error('Error deleting order:', error);
  //     showMessage('Failed to delete order.', 'bg-red-600');
  //   }
  // };


  const handleDelete = async (order) => {
  // 🚫 Block delete if invoice already generated
  if (order.Cpid > 0) {
    showMessage(
      `Invoice already generated for Bill No ${order.BIllNo}. Cannot delete.`,
      'bg-red-600'
    );
    return;
  }

  try {
    await api.DeleteSimpleOrderAPI(order.PoId, orderDate, itemType);
    showMessage('Order deleted successfully.', 'Delete');
    loadOrders();
  } catch (error) {
    console.error('Error deleting order:', error);
    showMessage('Failed to delete order.', 'bg-red-600');
  }
};

  const handleUpdate = async (order) => {
    const payload = {
      PoId: order.PoId,
      PayMode: order.Paymode,
      DeliveryPerson: order.DelieryPerson,
      DeliveryRemark: order.deliveryRemark,
      PaymentRemark: order.PaymentRemark,
      User: sessionStorage.getItem("username") || "UnknownUser",
      Sessid: "1"
    };
    try {
      await api.UPdateOrderRowFdsAPI(payload);
      showMessage('Order updated successfully.', 'Update');
      loadOrders();
    } catch (error) {
      console.error('Error updating order:', error);
      showMessage('Failed to update order.', 'bg-red-600');
    }
  };

  const handleSave = async () => {
    const payload = {
      AsOndate: orderDate,
      ItemType: itemType === 'ALL' ? '' : itemType,
      UserName: sessionStorage.getItem("username") || "UnknownUser",
      SessId: "1",
      Items: orders.map(order => ({
        Slno: order.Slno,
        Area: order.Area,
        DCApl: order.DCApl,
        Vid: order.Vid,
        VCode: order.VCode,
        Customer: order.Customer,
        ItemId: order.itemid,
        ItemNo: order.ItemNo,
        Partdesc: order.Partdesc,
        Qty: order.Qty,
        Rate: order.Rate,
        Amount: order.Amount,
        OtherQty: order.OtherQty,
        OtherAmount: order.OtherAmount,
        NetAmount: order.NetAmount,
        Paymode: order.Paymode,
        BillStatus: order.BillStatus,
        BIllNo: order.BIllNo,
        Route: order.Route,
        DelieryPerson: order.DelieryPerson,
        PoId: order.PoId,
        SelectItem: order.SelectItem,
        Cpid: order.Cpid,
        PaymentRemark: order.PaymentRemark,
        DeliveryRemark: order.deliveryRemark,
        ClBalance: order.ClBalance,
        PaymentCycle: order.PaymentCycle,
        Orid: order.Orid
      }))
    };
    try {
      await api.SaveOrderProcessAPI(payload);
      showMessage('Orders saved successfully.', 'Update');
      loadOrders();
    } catch (error) {
      console.error('Error saving orders:', error);
      showMessage('Failed to save orders.', 'bg-red-600');
    }
  };

  const handleInvoiceRaised = async (poId) => {
    try {
      const response = await api.SimplePotoInvoiceAPI({
        PoId: poId,
        UserName: sessionStorage.getItem("username") || "UnknownUser",
        SessId: "1"
      });
      if (response.SimplePotoInvoiceAPIjs && response.SimplePotoInvoiceAPIjs.Table[0]) {
        const { Result, CpId, InvNo } = response.SimplePotoInvoiceAPIjs.Table[0];
        showMessage(`${Result} - InvNo: ${InvNo}`, 'Update');
      }
      loadOrders();
    } catch (error) {
      console.error('Error raising invoice:', error);
      showMessage('Failed to raise invoice.', 'bg-red-600');
    }
  };
const filterOrders = () => {
  let filtered = orders.filter(order => true);

  if (searchInput.trim()) {
    const q = searchInput.toLowerCase();
    filtered = filtered.filter(order =>
      order.Customer?.toLowerCase().includes(q) ||
      String(order.BIllNo || "").includes(q) ||   // ✅ correct key
      String(order.VCode || "").includes(q)
    );
  }

  setFilteredOrders(filtered);
  setTotalOrders(filtered.length);

  setTotalClBalance(
    filtered.reduce((sum, o) => sum + (o.ClBalance || 0), 0)
  );

  setTotalNetAmount(
    filtered.reduce((sum, o) => sum + (o.NetAmount || 0), 0)
  );
};


  const loadOrders = async () => {
    // showMessage('Loading orders...', 'bg-gray-800');

    try {
      const username = sessionStorage.getItem("username") || "UnknownUser";
      const response = await api.OrderProcessAPI(orderDate, itemType === 'ALL' ? '' : itemType, '1', username);
      if (response.OrderProcessAPIjs) {
        const tableData = response.OrderProcessAPIjs.Table || [];
        setOrders(tableData);
        setPayModes(response.OrderProcessAPIjs.Table1 || []);
        setDeliveryPersons(response.OrderProcessAPIjs.Table3 || []);
        setOrderSummaryData(response.OrderProcessAPIjs.Table4 || []);
        setSelectedOrderIds([]);

       
        // showMessage(`Found ${filtered.length} orders.`, 'bg-green-600');
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  };


  useEffect(() => {
     filterOrders();
   }, [itemType, searchInput, orders]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRefItemType.current && !dropdownRefItemType.current.contains(event.target)) {
        setDropdownOpenItemType(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onLogout={handleLogout} />
      <main className="p-2 sm:p-1 md:ml-64">
        <div id="app" className="mx-auto overflow-hidden bg-white shadow-2xl max-w-7xl rounded-xl">
      <header className="
  bg-orange-500 text-white
  p-2
  flex flex-col gap-2
  sm:flex-row sm:items-center sm:justify-between
">
  {/* Top row (Back + Title for mobile) */}
  <div className="flex items-center justify-between sm:justify-start sm:gap-4">
    <button
      onClick={() => navigate('/dashboard')}
      className="
        inline-flex items-center gap-1
        px-3 py-1
        text-gray-800 font-semibold
        bg-gray-200 hover:bg-gray-300
        rounded-full shadow transition
        text-sm
      "
    >
      ← Back
    </button>

    {/* Mobile title */}
    <h1 className="text-lg font-bold sm:hidden">
      Order Process
    </h1>
  </div>

  {/* Desktop title */}
  <h1 className="hidden sm:block text-xl font-bold sm:text-2xl text-center flex-1">
    Order Process
  </h1>

  {/* Action buttons */}
  <div className="
    flex flex-wrap gap-2
    justify-end
  ">
    <button
      onClick={handleSave}
      className="
        px-3 py-1
        font-semibold text-orange-500
        bg-white rounded-lg
        shadow hover:bg-gray-100
        text-sm
      "
    >
      Save
    </button>

    <button
    onClick={() => navigate('/dashboard')}
      className="
        px-3 py-1
        font-semibold text-orange-500
        bg-white rounded-lg
        shadow hover:bg-gray-100
        text-sm
      "
    >
      Close
    </button>

    <button
      onClick={() => navigate('/orderform')}
      className="
        inline-flex items-center gap-1
        px-3 py-1
        font-semibold text-orange-500
        bg-white rounded-lg
        shadow hover:bg-gray-100
        text-sm
      "
    >
      <Plus className="w-4 h-4" />
      New Order
    </button>
  </div>
</header>


        <div className="p-2 sm:p-2">
          <div className="flex mb-1 border-b">
            <button
              onClick={() => setActiveTab('OrderProcess')}
              className={`px-2 py-2 ${activeTab === 'OrderProcess' ? 'border-b-2 border-orange-500 text-orange-600' : 'text-gray-600'}`}
            >
              Order Process
            </button>
            <button
              onClick={() => setActiveTab('OrderSummary')}
              className={`px-2 py-2 ${activeTab === 'OrderSummary' ? 'border-b-2 border-orange-500 text-orange-600' : 'text-gray-600'}`}
            >
              Order Summary
            </button>
          </div>
          {activeTab === 'OrderProcess' && (
          <>
          <div className="grid grid-cols-1 gap-2 p-2 border-orange-500 shadow-inner bor3der mb- sm:grid-cols-2 lg:grid-cols-5 rounded-xl bg-gray-50">
            <div className="flex flex-col">
              <label htmlFor="order-date" className="text-sm font-medium text-gray-700">Order Date</label>
              <input type="date" id="order-date" value={orderDate} onChange={(e) => setOrderDate(e.target.value)} className="p-1 mt-1 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500" />
            </div>
            <div className="flex flex-col">
              <label htmlFor="item-type" className="text-sm font-medium text-gray-700">Item Type</label>
              <div className="relative" ref={dropdownRefItemType}>
                <input
                  type="text"
                  value={searchTextItemType}
                  onChange={(e) => {
                    setSearchTextItemType(e.target.value);
                    setDropdownOpenItemType(true);
                    setSelectedIndex(0);
                  }}
                  onClick={() => {
                    setDropdownOpenItemType(!dropdownOpenItemType);
                    setSelectedIndex(0);
                  }}
                  onKeyDown={(e) => {
                    if (!dropdownOpenItemType) return;
                    if (e.key === 'ArrowDown') {
                      e.preventDefault();
                      setSelectedIndex(prev => Math.min(prev + 1, filteredItemTypes.length - 1));
                    } else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      setSelectedIndex(prev => Math.max(prev - 1, 0));
                    } else if (e.key === 'Enter') {
                      e.preventDefault();
                      if (filteredItemTypes[selectedIndex]) {
                        setItemType(filteredItemTypes[selectedIndex].ItemType);
                        setSearchTextItemType(filteredItemTypes[selectedIndex].ItemType);
                        setDropdownOpenItemType(false);
                      }
                    }
                  }}
                  placeholder="Search Item Type..."
                  className="w-full p-1 mt-1 border border-gray-300 rounded-lg cursor-pointer focus:ring-orange-500 focus:border-orange-500"
                />
                <ChevronDown className="absolute w-4 h-4 text-gray-400 transform -translate-y-1/2 pointer-events-none right-2 top-1/2" />
                {dropdownOpenItemType && (
                  <ul className="absolute z-50 w-full mt-1 overflow-y-auto bg-white border rounded-md shadow-lg max-h-60">
                    {filteredItemTypes.length > 0 ? (
                      filteredItemTypes.map((type, index) => (
                        <li
                          key={index}
                          onClick={() => {
                            setItemType(type.ItemType);
                            setSearchTextItemType(type.ItemType);
                            setDropdownOpenItemType(false);
                          }}
                          className={`px-4 py-2 cursor-pointer ${selectedIndex === index ? 'bg-orange-200' : 'hover:bg-orange-100'}`}
                        >
                          {type.ItemType}
                        </li>
                      ))
                    ) : (
                      <li className="px-4 py-2 text-gray-500">No item types found</li>
                    )}
                  </ul>
                )}
              </div>
            </div>
            <div className="flex flex-col items-center justify-end">
              <button onClick={loadOrders} className="flex items-center justify-center px-2 py-1 font-semibold text-white transition bg-orange-500 rounded-lg shadow-md hover:bg-orange-600 focus:outline-none focus:ring-4 focus:ring-orange-500/50">
                 Refresh
              </button>
            </div>
            <div className="flex flex-col justify-end">
              <div className="flex gap-2 mb-2">
                <button onClick={() => setSelectedOrderIds(filteredOrders.map(o => o.PoId))} className="px-2 py-1 text-xs font-medium text-blue-600 bg-blue-100 rounded hover:bg-blue-200">Check All</button>
                <button onClick={() => setSelectedOrderIds([])} className="px-2 py-1 text-xs font-medium text-red-600 bg-red-100 rounded hover:bg-red-200">Clear All</button>
              </div>
              <input type="text" id="search-input" placeholder="Search Customer / Bill No." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} className="w-full p-1 text-sm border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500" />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 mb-2 md:grid-cols-3">
  <div className="px-2 py-1 text-center border border-blue-200 rounded-lg bg-blue-50">
    <p className="text-xs font-medium leading-tight text-blue-600">
      Total Orders Displayed
    </p>
    <p className="text-xl font-bold leading-none text-blue-800">
      {totalOrders}
    </p>
  </div>

  <div className="px-2 py-1 text-center border border-red-200 rounded-lg bg-red-50">
    <p className="text-xs font-medium leading-tight text-red-600">
      Total Cl. Balance Sum
    </p>
    <p className="text-xl font-bold leading-none text-red-800">
      ₹ {totalClBalance.toFixed(2)}
    </p>
  </div>

  <div className="px-2 py-1 text-center border border-green-200 rounded-lg bg-green-50">
    <p className="text-xs font-medium leading-tight text-green-600">
      Total Net Amount Sum
    </p>
    <p className="text-xl font-bold leading-none text-green-800">
      ₹ {totalNetAmount.toFixed(2)}
    </p>
  </div>
</div>


               <div className="flex justify-end mb-2">

                
              <button
              
  onClick={() => {
    const headers =
      "SlNo,Poid,Vid,CCode,Customer,ItemId,Item,ClBalance,PC,ItemDesc,Qty,Rate,Amount,OtherQty,OtherAmount,NetAmount,BillNo,Mode,Delivery,Route,Cpid,PaymentRemark,DeliveryRemark\n";

    const csvContent =
      "data:text/csv;charset=utf-8," +
      headers +
      filteredOrders
        .map((order, index) =>
          [
            index + 1,
            order.PoId,
            order.Vid,
            order.VCode,
            `"${order.Customer}"`,
            order.itemid,
            order.ItemNo,
            order.ClBalance || 0,
            order.PaymentCycle || "",
            `"${order.Partdesc}"`,
            order.Qty || 0,
            order.Rate || 0,
            order.Amount || 0,
            order.OtherQty || 0,
            order.OtherAmount || 0,
            order.NetAmount || 0,
            order.BIllNo,
            order.Paymode,
            order.DelieryPerson,
            order.Route,
            order.Cpid,
            `"${order.PaymentRemark || ""}"`,
            `"${order.deliveryRemark || ""}"`,
          ].join(",")
        )
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "order_process.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }}
className="px-2 py-1 font-semibold inline-flex w-auto self-start text-white bg-blue-500 hover:bg-blue-700 rounded-full shadow transition"
        >
       📄 Export Excel
</button>

               </div>

          <div
   className="overflow-auto border border-orange-400 rounded-lg shadow-inner"
   style={{ maxHeight: "calc(100vh - 12rem)" }}
 >
  <table className="min-w-full text-xs border-collapse">
    <thead className="sticky top-0 z-10 bg-gray-100 border-b">
      <tr>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">Delete</th>
        <th className="hidden">Orid</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">SlNo</th>
        <th className="hidden">Poid</th>
        <th className="hidden">Vid</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">CCode</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">Customer</th>
        <th className="hidden">ItemId</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">Item</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-right uppercase">ClBalance</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-right uppercase">PC</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">ItemDesc</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-right uppercase">Qty</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-right uppercase">Rate</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-right uppercase">Amount</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-right uppercase">OtherQty</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-right uppercase">OtherAmount</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-right uppercase">NetAmount</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">Invoice</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">BillNo</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">Mode</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">Delivery</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">Route</th>
        <th className="hidden">Cpid</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-center uppercase">Select</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">PaymentRemark</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">DeliveryRemark</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">Actions</th>
        <th className="px-2 py-1 text-[11px] font-semibold text-left uppercase">Edit Order</th>
      </tr>
    </thead>

    <tbody className="divide-y divide-gray-100">
      {filteredOrders.length === 0 ? (
        <tr>
          <td colSpan="27" className="py-6 text-center text-gray-400">
            No orders found
          </td>
        </tr>
      ) : (
        filteredOrders.map((order, index) => (
          <tr key={order.id} className="hover:bg-blue-50">
            <td className="px-2 py-1">
              {/* <button
                onClick={() => handleDelete(order)}
                className="text-red-600 hover:text-red-800"
              >
                🗑
              </button> */}

              <td className="px-2 py-1">
  {order.Cpid > 0 ? (
    <span
      title="Invoice already generated"
      className="text-gray-400 cursor-not-allowed"
    >
      🗑
    </span>
  ) : (
    <button
      onClick={() => handleDelete(order)}
      className="text-red-600 hover:text-red-800"
      title="Delete Order"
    >
      🗑
    </button>
  )}
</td>

            </td>
            <td className="hidden">{order.Orid}</td>
            <td className="px-2 py-1">{index + 1}</td>
            <td className="hidden">{order.PoId}</td>
            <td className="hidden">{order.Vid}</td>
            <td className="px-2 py-1">{order.VCode}</td>
            <td className="px-2 py-1">{order.Customer}</td>
            <td className="hidden">{order.itemid}</td>
            <td className="px-2 py-1">{order.ItemNo}</td>

            <td className="px-2 py-1 text-right">
              ₹ {(order.ClBalance || 0).toFixed(2)}
            </td>

            <td className="px-2 py-1">
              <input
 type="text"
 value={order.PaymentCycle ?? ""}
 onChange={(e) =>
   updateRemark(
     order.PoId,                 // ✅ FIXED
     "PaymentCycle",             // ✅ FIXED
     e.target.value === "" ? "" : Number(e.target.value)
   )
 }
 className="w-14 px-1 py-0.5 text-xs text-right border rounded focus:ring-1 focus:ring-orange-300"
/>

            </td>

            <td className="px-2 py-1">{order.Partdesc}</td>

            <td className="px-2 py-1 text-right">{order.Qty || 0}</td>
            <td className="px-2 py-1 text-right">₹ {(order.Rate || 0).toFixed(2)}</td>
            <td className="px-2 py-1 text-right">₹ {(order.Amount || 0).toFixed(2)}</td>
            <td className="px-2 py-1 text-right">{order.OtherQty || 0}</td>
            <td className="px-2 py-1 text-right">₹ {(order.OtherAmount || 0).toFixed(2)}</td>
            <td className="px-2 py-1 text-right">₹ {(order.NetAmount || 0).toFixed(2)}</td>

            <td className="px-2 py-1">
              <button
                onClick={() => handleInvoiceRaised(order.PoId)}
                className="px-1.5 py-0.5 text-[11px] text-blue-600 bg-blue-100 rounded hover:bg-blue-200"
              >
                Invoice
              </button>
            </td>

            <td className="px-2 py-1">{order.BIllNo}</td>

            <td className="px-2 py-1">
              <div className="relative">
                <input
                  type="text"
                  // value={modeDropdownStates[order.PoId]?.search || order.Paymode || ''}
                  value={
  modeDropdownStates[order.PoId]?.search !== undefined
    ? modeDropdownStates[order.PoId].search
    : order.Paymode || ''
}
                  onChange={(e) => {

                    const value = e.target.value;

                    setModeDropdownStates(prev => ({...prev, [order.PoId]: {open: value !== '', search: value, 
                      selectedIndex: 0}}));

                  }}
                  onFocus={() => setModeDropdownStates(prev => ({...prev, [order.PoId]: {open: true, search: order.Paymode || '', selectedIndex: 0}}))}
                  // onBlur={() => setTimeout(() => setModeDropdownStates(prev => ({...prev, [order.PoId]: {open: false, search: order.Paymode || '', selectedIndex: 0}})), 200)}
                  
                  onKeyDown={(e) => {
                    if (!modeDropdownStates[order.PoId]?.open) return;
                    const filtered = filteredPayModes.filter(m => m.PayMode.toLowerCase().includes((modeDropdownStates[order.PoId]?.search || '').toLowerCase()));
                    if (e.key === 'ArrowDown') {
                      e.preventDefault();
                      setModeDropdownStates(prev => ({...prev, [order.PoId]: {...prev[order.PoId], selectedIndex: Math.min(prev[order.PoId].selectedIndex + 1, filtered.length - 1)}}));
                    } else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      setModeDropdownStates(prev => ({...prev, [order.PoId]: {...prev[order.PoId], selectedIndex: Math.max(prev[order.PoId].selectedIndex - 1, 0)}}));
                    } else if (e.key === 'Enter') {
                      e.preventDefault();
                      if (filtered[modeDropdownStates[order.PoId]?.selectedIndex]) {
                        updateRemark(order.PoId, 'Paymode', filtered[modeDropdownStates[order.PoId].selectedIndex].PayMode);
                        setModeDropdownStates(prev => ({...prev, [order.PoId]: {open: false, search: filtered[modeDropdownStates[order.PoId].selectedIndex].PayMode, selectedIndex: 0}}));
                      }
                    }
                  }}
                  className="w-24 px-1 py-0.5 text-xs border rounded"
                />
                <ChevronDown className="absolute w-4 h-4 text-gray-400 transform -translate-y-1/2 pointer-events-none right-2 top-1/2" />
                {modeDropdownStates[order.PoId]?.open && (
                  <ul className="absolute z-10 w-24 mt-1 overflow-y-auto bg-white border rounded shadow max-h-40">
                    {filteredPayModes.filter(m => m.PayMode.toLowerCase().includes((modeDropdownStates[order.PoId]?.search || '').toLowerCase())).map((mode, idx) => (
                      <li key={idx} onClick={() => { updateRemark(order.PoId, 'Paymode', mode.PayMode); setModeDropdownStates(prev => ({...prev, [order.PoId]: {open: false, search: mode.PayMode, selectedIndex: 0}})); }} className={`px-2 py-1 cursor-pointer ${modeDropdownStates[order.PoId]?.selectedIndex === idx ? 'bg-orange-200' : 'hover:bg-gray-100'}`}>{mode.PayMode}</li>
                    ))}
                  </ul>
                )}
              </div>
            </td>

            <td className="px-2 py-1">{order.DelieryPerson}</td>
            <td className="px-2 py-1">{order.Route}</td>
            <td className="hidden">{order.Cpid}</td>

            <td className="px-2 py-1 text-center">
  <input
    type="checkbox"
    checked={order.SelectItem === 1}
    onChange={(e) => {
      const checked = e.target.checked;

      // update visual selection list (existing logic)
      if (checked) {
        setSelectedOrderIds(prev => [...prev, order.PoId]);
      } else {
        setSelectedOrderIds(prev => prev.filter(id => id !== order.PoId));
      }

      // ✅ THIS IS THE IMPORTANT PART
      setOrders(prev =>
        prev.map(o =>
          o.PoId === order.PoId
            ? { ...o, SelectItem: checked ? 1 : 0 }
            : o
        )
      );
    }}
  />
</td>


            <td className="px-2 py-1">
              <input
                type="text"
                value={order.PaymentRemark || ""}
                onChange={(e) =>
                  updateRemark(order.PoId, "PaymentRemark", e.target.value)
                }
                className="w-full px-1 py-0.5 text-xs border rounded"
              />
            </td>

            <td className="px-2 py-1">
              <input
                type="text"
                value={order.deliveryRemark || ""}
                onChange={(e) =>
                  updateRemark(order.PoId, "deliveryRemark", e.target.value)
                }
                className="w-full px-1 py-0.5 text-xs border rounded"
              />
            </td>

            <td className="px-2 py-1 whitespace-nowrap">
              <button
                onClick={() => handleUpdate(order)}
                className="px-1.5 py-0.5 text-[11px] text-blue-600 bg-blue-100 rounded hover:bg-blue-200"
              >
                Update
              </button>
            </td>

<td>
            <button
  onClick={async () => {
    const response = await api.EditFdOrderlistAPI(order.Orid);
    const editData = response?.EditFdOrderlistAPIjs;
    navigate('/orderform', { state: { editData } });
  }}
  className="px-1.5 py-0.5 text-[11px] text-indigo-600 bg-indigo-100 rounded hover:bg-indigo-200"
>
  Edit
</button>
</td>
          </tr>
        ))
      )}
    </tbody>
  </table>
</div>

          </>
          )}
          {activeTab === 'OrderSummary' && (
            <>
              <div className="flex justify-end mb-2">
              <button
  onClick={() => {
    const csvContent =
      "data:text/csv;charset=utf-8," +
      "Slno,Item,TotCount\n" +
      orderSummaryData
        .map(row => `${row.slno},${row.Item},${row.TotCnt}`)
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "order_summary.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }}
  className="
    inline-flex items-center gap-2
    px-3 py-1.5
    text-[13px] font-semibold
    text-white
    bg-slate-700
    rounded-md
    shadow-sm
    hover:bg-slate-800
    focus:outline-none
    focus:ring-2 focus:ring-slate-400
    transition-colors
  "
>
  Export CSV
</button>

              </div>
              <div className="overflow-x-auto border border-orange-500 rounded-lg shadow-inner">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-200">
                    <tr>
                      <th className="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">Slno</th>
                      <th className="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">Item</th>
                      <th className="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">TotCount</th>
                    </tr>
                  </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                  {orderSummaryData.map((item, idx) => (
                    <tr key={idx} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm whitespace-nowrap">{item.slno}</td>
                      <td className="px-4 py-3 text-sm whitespace-nowrap">{item.Item}</td>
                      <td className="px-4 py-3 text-sm whitespace-nowrap">{item.TotCnt}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>)}
        </div>
      </div>
      </main>

      {messageVisible && (
        <div className={`fixed bottom-4 right-4 ${messageColor} text-white p-4 rounded-lg shadow-xl z-50`}>
          {message}
        </div>
      )}
    </div>
  );
};

export default OrderProcess;